<template>
    <div class="createStoreProdcut">


        <div class="basic_info">
            <div class="title">{{ $t('other.a2813') }}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a66')">

                        <el-upload class="avatar-uploader" :headers="token"
                            action="https://erp.shopsbu.com/service/access/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>

                    </el-form-item>
                    <el-form-item :label="$t('other.a2814')" prop="groupName">
                        <el-input v-model="ruleForm.groupName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a735')" prop="itemSku">
                        <el-input style="width:300px" v-model="ruleForm.itemSku"></el-input>
                    </el-form-item>

                </el-form>
            </div>
        </div>

        <div class="basic_info">
            <div class="title">{{ $t('other.a2139') }}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">

                    <el-form-item label="" prop="name">
                        <el-table :data="ruleForm.storeItems" style="width: 100%">
                            <el-table-column prop="date" :label="$t('other.a2139')">
                                <template slot-scope="scope" slot="header">
                                    <div style="display: flex;justify-content: space-between;">
                                        <span style="padding-right:25px">{{ $t('other.a2139') }}</span>
                                        <el-input size="mini" style="width:80px" @blur="setName(1)" v-model="skuName"
                                            :placeholder="$t('other.a1248')"></el-input>
                                        <el-checkbox v-model="skuNameChecked" @change="changeCheck">
                                            <el-tooltip class="item" effect="dark" content="勾选代表“仓库子商品名”=“仓库子SKU”"
                                                placement="top">
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </el-checkbox>
                                    </div>
                                </template>
                                <template slot-scope="props">
                                    <el-input v-model="props.row.skuName" :placeholder="$t('other.a2816')"
                                        @blur="setSkuName(props.row)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" :label="$t('other.a2815')">
                                <template slot-scope="scope" slot="header">
                                    <span style="padding-right:25px">{{ $t('other.a2815') }}</span>
                                    <el-input size="mini" style="width:80px" @blur="setName(2)" v-model="variationName"
                                        :placeholder="$t('other.a1248')" :disabled="skuNameChecked"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input v-model="props.row.variationName" :placeholder="$t('other.a2817')"
                                        :disabled="skuNameChecked"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="scope" slot="header">
                                    <span style="padding-right:25px">{{ $t('other.a1255') }}(cm)</span>
                                    <el-input size="mini" style="width:80px" @blur="setPrice(1)" v-model="packageLength"
                                        :placeholder="$t('other.a1248')"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input @blur="props.row.packageLength = Number(props.row.packageLength)"
                                        v-model="props.row.packageLength" :placeholder="$t('other.a2818')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" :label="$t('other.a310')">
                                <template slot-scope="scope" slot="header">
                                    <span style="padding-right:25px">{{ $t('other.a1256') }}(cm)</span>
                                    <el-input size="mini" style="width:80px" @blur="setPrice(2)" v-model="packageWidth"
                                        :placeholder="$t('other.a1248')"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input @blur="props.row.packageWidth = Number(props.row.packageWidth)"
                                        v-model="props.row.packageWidth" :placeholder="$t('other.a2819')"></el-input>
                                </template>

                            </el-table-column>
                            <el-table-column prop="date" :label="$t('other.a310')">
                                <template slot-scope="scope" slot="header">
                                    <span style="padding-right:25px">{{ $t('other.a1257') }}(cm)</span>
                                    <el-input size="mini" style="width:80px" @blur="setPrice(3)" v-model="packageHeight"
                                        :placeholder="$t('other.a1248')"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input @blur="props.row.packageHeight = Number(props.row.packageHeight)"
                                        v-model="props.row.packageHeight" :placeholder="$t('other.a2820')"></el-input>
                                </template>

                            </el-table-column>
                            <el-table-column prop="date" :label="$t('other.a310')">
                                <template slot-scope="scope" slot="header">
                                    <span style="padding-right:25px">{{ $t('other.a1516') }}(kg)</span>
                                    <el-input size="mini" style="width:80px" @blur="setPrice(4)" v-model="weight"
                                        :placeholder="$t('other.a1248')"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input @blur="props.row.weight = Number(props.row.weight)" v-model="props.row.weight"
                                        :placeholder="$t('other.a2421')"></el-input>
                                </template>

                            </el-table-column>

                            <el-table-column width="80">
                                <template slot-scope="props">
                                    <i v-show="props.$index == 0" @click="addItmes(0, props.$index)"
                                        class="iconfont icon-zengjiatianjiajiajian"></i>
                                    <i v-show="!props.$index == 0" @click="addItmes(1, props.$index)"
                                        class="iconfont icon-jianshao1"></i>
                                </template>
                            </el-table-column>
                        </el-table>


                    </el-form-item>

                </el-form>
            </div>
        </div>



        <div class="footer">
            <div style="margin-right:50px">
                <el-button style="margin-right:60px" type="primary" @click="cancel()">{{ $t('other.a106') }}</el-button>
                <el-button type="primary" @click="saveItem()">{{ $t('other.a2773') }}</el-button>
            </div>
        </div>


    </div>
</template>

<script>
import api from '../../../api/api'
import draggable from "vuedraggable"
import { mapState, mapMutations } from 'vuex'
import { resolve } from 'path'
export default {
    data() {
        return {
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,

            ruleForm: {
                itemSku: '',
                image: '',
                groupName: '',
                userId: JSON.parse(localStorage.getItem('userInfo')).userId,
                storeItems: [{
                    packageHeight: '',
                    packageLength: '',
                    packageWidth: '',
                    skuName: '',
                    weight: '',
                    packageHeight: '',
                    variationName: '',
                    image: '',
                    storeId: 0
                }]

            },
            rules: {
                itemSku: [
                    { required: true, message: this.$t('other.a2821'), trigger: 'blur' },
                    { min: 1, max: 80, message: this.$t('other.a2822'), trigger: 'blur' }
                ],
                groupName: [
                    { required: false, message: '', trigger: 'blur' },
                    { min: 1, max: 120, message: this.$t('other.a2823'), trigger: 'blur' }
                ],
                description: [
                    { required: true, message: this.$t('other.a1284'), trigger: 'blur' }
                ],
                categories: [
                    { required: true, message: this.$t('other.a1285'), trigger: 'blur' }
                ],
            },
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            imageUrl: '',
            skuNameChecked: false,
            skuName: '',
            variationName: '',
            packageLength: '',
            packageWidth: '',
            packageHeight: '',
            weight: '',
            storeId: 0,
            component: null,
            pathUrl: '',
            addition: ''





        }
    },

    components: {
        draggable
    },

    inject: ['reload'],

    computed: {//这一部分直接拿过来用的
        ...mapState({
            ModelData: state => state.common.ModelData



        }),





    },

    watch: {

    },



    created() {
        this.init()

    },


    methods: {

        init() {
            this.storeId = JSON.parse(this.$route.query.storeId)
            this.component = JSON.parse(this.$route.query.components)
            this.pathUrl = JSON.parse(this.$route.query.from)
            this.addition = JSON.parse(this.$route.query.addition)
            console.log(this.storeId, this.component, this.pathUrl)

        },




        saveItem() {
            console.log(this.ruleForm)
            this.ruleForm.storeId = this.storeId
            this.ruleForm.storeItems.forEach(p => {
                p.storeId = this.storeId,
                    p.component = this.component
                p.addition = this.addition
            })

            api
                .addStoreItemGroupNotProduct(this.ruleForm)
                .then(res => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('other.a1502'))
                        setTimeout(() => {
                            this.cancel()
                        }, 800)
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
        cancel() {
            this.$router.push(this.pathUrl)
        },
        handleAvatarSuccess(res, file) {
            console.log(file.response.data)
            this.imageUrl = URL.createObjectURL(file.raw);
            this.ruleForm.image = file.response.data
            console.log(this.ruleForm)
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;


        },
        changeCheck(e) {
            if (e) {
                this.ruleForm.storeItems.forEach(p => {
                    p.variationName = p.skuName
                })
                this.variationName = this.skuName
            }
        },
        setSkuName(item) {
            if (this.skuNameChecked) {
                item.variationName = item.skuName
            }
        },
        setName(num) {
            if (num == 1) {
                this.ruleForm.storeItems.forEach(p => {
                    p.skuName = this.skuName
                    if (this.skuNameChecked) {
                        p.variationName = p.skuName
                        this.variationName = this.skuName
                    }
                })
            } else if (num == 2) {
                this.ruleForm.storeItems.forEach(p => {
                    p.variationName = this.variationName
                })
            }
        },
        setPrice(num) {
            console.log(this.ruleForm)
            if (num == 1) {
                this.ruleForm.storeItems.forEach(p => {
                    p.packageLength = this.packageLength
                })
            } else if (num == 2) {
                this.ruleForm.storeItems.forEach(p => {
                    p.packageWidth = this.packageWidth
                })
            } else if (num == 3) {
                this.ruleForm.storeItems.forEach(p => {
                    p.packageHeight = this.packageHeight
                })
            } else if (num == 4) {
                this.ruleForm.storeItems.forEach(p => {
                    p.weight = this.weight
                })
            }


        },

        addItmes(num, index) {
            if (num == 0) {
                this.ruleForm.storeItems.push({
                    packageHeight: '',
                    packageLength: '',
                    packageWidth: '',
                    skuName: '',
                    weight: '',
                    packageHeight: '',
                    variationName: '',
                    image: '',
                    storeId: 0
                })
            } else {
                this.ruleForm.storeItems.splice(index, 1)
            }
        },









    }
}

</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.createStoreProdcut {

    // flex:1;
    // margin: 50px 0 0 223px;

    background-color: #eee;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;


    .footer {
        position: fixed;
        background-color: #fff;
        width: 86%;
        bottom: 0;
        height: 70px;
        margin-left: -20px;
        border-top: 1px solid #eee;
        z-index: 15;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        box-shadow: 5px ​4px 23px -6px #606266;

    }

    .basic_info {

        background-color: #fff;
        padding: 0 16px;
        margin-bottom: 25px;



        .attribute {
            display: inline-block;
            min-width: 350px;
            box-sizing: border-box;
            margin-bottom: 10px;

            .attribute_desc {
                display: inline-block;
                width: 150px;
                text-align: right;
            }
        }

        .title {
            height: 68px;
            line-height: 68px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em !important;
            font-family: Roboto, sans-serif !important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail {
            padding: 15px 0;

            .singSku_wrapper {
                display: flex;

                .singSku {
                    display: flex;
                    margin-right: 30px;

                    .inputBox {
                        display: inline-block;
                        width: 180px;
                    }
                }
            }


        }

        .listitem {
            display: inline-block;
            width: 120px;
            height: 120px;
            border-radius: 3px;
            cursor: pointer;
            border: 1px dashed #c0ccda;
            margin: 0 5px;
            position: relative;
        }

        .pic_desc {
            position: absolute;
            bottom: -45px;
            left: 40px;
        }

        .cateGory_wrapper {
            position: relative;
            box-shadow: 0 5px 5px -3px #606266;
            height: 450px;



            .first_wrapper {
                position: absolute;
                top: 0;
                left: 0;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .first_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .second_wrapper {
                position: absolute;
                top: 0;
                left: 350px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .second_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .three_wrapper {
                position: absolute;
                top: 0;
                left: 700px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .three_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .four_wrapper {
                position: absolute;
                top: 0;
                left: 1050px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .four_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }


            .category_title {
                position: relative;
                top: 0;
                left: 0;

            }



            .active:hover {
                background-color: #eee;
            }
        }

        .pic_box {

            width: 120px;
            height: 120px;
            position: absolute;
            z-index: 2;
        }

        .listitem::after {
            content: "+";
            font-size: 40px;

            position: absolute;
            top: 48px;
            left: 48px;
            z-index: 1;


        }

        .delete {

            width: 120px;
            background-color: rgba(0, 0, 0, .87);
            color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: center;
            display: none;
            z-index: 99
        }

        .deleteActive {
            display: block;
            z-index: 99
        }



        .icon-zengjiatianjiajiajian {
            color: rgb(64, 211, 242);
            cursor: pointer;
            font-size: 20px;
        }

        .icon-jianshao1 {
            color: rgb(246, 97, 109);
            cursor: pointer;
            font-size: 20px;
        }



    }


    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        border: 1px dashed #66b1ff;
    }

    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }


}
</style>